import { render, staticRenderFns } from "./PlasticOrder.vue?vue&type=template&id=2d96be3d&"
import script from "./PlasticOrder.vue?vue&type=script&lang=js&"
export * from "./PlasticOrder.vue?vue&type=script&lang=js&"
import style0 from "./PlasticOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports